module.exports = __webpack_public_path__ + "static/media/lindale_logo_circle_invert.23520de0.svg";